<template>
    <section id="card-text-alignment">
      <b-card title="Filtros">
        <ProdutoModal ref="modalProduto"/>
        <b-row>
          <!-- <b-col md="5">
            <b-form-group
            >
              <label for="estabelecimento"><strong>Estabelecimento</strong></label>
              <b-form-select
                  id="per-page-select"
                  v-model="perPage"
                  :options="estabelecimentoOptions"
                  size="sm"
              ></b-form-select>
            </b-form-group>
          </b-col> -->
          <b-col md="12">
            <app-collapse >

              <app-collapse-item  title="Grupos" class="border mb-0" >
                <b-card class="border mb-0">
                <div class="demo-inline-spacing">
                  <b-form-checkbox
                     v-for="item in filtrosList.Grupos"
                      v-model="selectedGroupIds[item.produtogrupoid]"
                      :key="item.produtogrupoid"
                       @change="filtrarProdutos"
                  >
                    {{item.produtogrupo}}
                  </b-form-checkbox>
                </div>
                </b-card>
              </app-collapse-item>

              <app-collapse-item title="SubGrupos" class="border mb-0">
                <b-card class="border mb-0">
                <div class="demo-inline-spacing">
                  <b-form-checkbox
                      v-for="item in filtrosList.SubGrupos"
                      v-model="selectedSubGroupIds[item.produtosubgrupoid]"
                      :key="item.produtosubgrupoid"
                      @change="filtrarProdutos"
                  >
                    {{item.produtosubgrupo}}
                  </b-form-checkbox>
                </div>
                </b-card>
              </app-collapse-item>

              <app-collapse-item title="Aplicação" class="border mb-0">
                <b-card class="border mb-0">
                <div class="demo-inline-spacing">
                  <b-form-checkbox
                      v-for="item in filtrosList.ProdutoUsabilidade"
                      v-model="selectedUsabilidadeIds[item.produtoUsabilidadeId]"
                      :key="item.produtoUsabilidadeId"
                      @change="filtrarProdutos"
                  >
                    {{item.produtoUsabilidade}}
                  </b-form-checkbox>
                </div>
                </b-card>
              </app-collapse-item>
            </app-collapse>
          </b-col>
        </b-row>
        <br>
        <b-overlay :show="$store.getters['PTC_ProdutosClient/getIsLoading']">
        <b-table
            :striped="true"
            :bordered="true"
            :hover="true"
            :responsive="true"
            table-variant="secondary"
            :fields="fields"
            :items="paginatedItems"
            show-empty
            empty-text="Nenhum registro encontrado"
        >
          <!-- A virtual column -->
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #cell(item_id)="data">
            <div class="text-nowrap">
              {{ data.item.item_id }}
            </div>
          </template>

          <template #cell(item_descricao)="data">
            {{ data.item.item_descricao }}
          </template>

          <template #cell(caract)="data">
            <div
                class="d-flex"
                style="gap:5px"
            >
              <b-button
                  variant="success"
                  size="sm"
                  @click="abrirModal('caract', data.item)"
              >
                <feather-icon icon="FileTextIcon"/>
              </b-button>
            </div>
          </template>
          <template #cell(cond)="data">
            <div
                class="d-flex"
                style="gap:5px"
            >
              <b-button
                  variant="primary"
                  size="sm"
                  @click="abrirModal('cond', data.item)"
              >
                <feather-icon icon="FilePlusIcon"/>
              </b-button>
            </div>
          </template>
        </b-table>
        </b-overlay>
        <b-row>
          <b-col sm="5" md="4" class="my-1">
            <b-form-group
                label="paginação"
                label-for="per-page-select"
                label-cols-sm="6"
                label-cols-md="4"
                label-cols-lg="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
            >
              <b-form-select
                  id="per-page-select"
                  v-model="perPage"
                  :options="pageOptions"
                  size="sm"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="7" md="6" class="my-1">
            <b-pagination
                v-model="currentPage"
                :total-rows="getProdutos.Produtos.length"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>
    </section>
</template>

<script>
import { BFormSelect } from 'bootstrap-vue';
import PTC_ProdutoService from '@/services/PTC/PTC_Produtos.service';
import ProdutoModal from '@/views/app/PTC/Produtos/produtoModal.vue';
import { mapGetters } from 'vuex';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';

const ptc_ProdutoService = new PTC_ProdutoService();
export default {
  components: {
    ProdutoModal,
    AppCollapse,
    AppCollapseItem,
    BFormSelect,
  },
  data() {
    return {
      fields: [
        { key: 'item_id', label: 'Cod. Produto' },
        { key: 'item_descricao', label: 'Descrição' },
        { key: 'caract', label: 'Caract. Técnicas' },
        { key: 'cond', label: 'Cond. Fornecimento e Garantia' },
      ],
      selectedGroupIds: {},
      selectedSubGroupIds: {},
      selectedUsabilidadeIds: {},
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 50, 100],
      totalRows: 5,
      estabelecimentoOptions: [
        { value: '1', text: 'Matriz' },
        { value: '2', text: 'Filial' },
      ],
    };
  },
  watch: {
    perPage() {
      this.currentPage = 1;
    },
  },
  methods: {
    abrirModal(tipoOperacao, dados = null) {
      this.$refs.modalProduto.abrirModal(tipoOperacao, dados);
    },
    async listProdutos() {
      await ptc_ProdutoService.retornaProduto();
      await ptc_ProdutoService.filtrosList();
    },
    async estabOptions() {
      const obj = this.getProdutos.Produtos;
      const estab = obj.map((item) => ({
        value: item.estabelecimentoId,
        text: item.estabelecimentorazaosocial,
      }));
      this.estabelecimentoOptions = estab;
    },
    async filtrarProdutos() {
      let queries = null;
      const selectedGrupsIds = Object.keys(this.selectedGroupIds).filter(
        (key) => this.selectedGroupIds[key],
      );

      const selectedSubGrupsIds = Object.keys(this.selectedSubGroupIds).filter(
        (key) => this.selectedSubGroupIds[key],
      );

      const selectedUsabilidadeIds = Object.keys(this.selectedUsabilidadeIds).filter(
        (key) => this.selectedUsabilidadeIds[key],
      );

      if (selectedGrupsIds.length > 0) {
        queries = {
          ...queries,
          prodGrpId: selectedGrupsIds.join(','),
        };
      }

      if (selectedSubGrupsIds.length > 0) {
        queries = {
          ...queries,
          prodSubGrpId: selectedSubGrupsIds.join(','),
        };
      }

      if (selectedUsabilidadeIds.length > 0) {
        queries = {
          ...queries,
          prodUsabId: selectedUsabilidadeIds.join(','),
        };
      }

      await ptc_ProdutoService.retornaProduto(queries);
    },
  },
  async mounted() {
    await this.listProdutos();
    await this.estabOptions();
  },
  computed: {
    ...mapGetters({
      getProdutos: 'PTC_ProdutosClient/getPodutos',
      filtrosList: 'PTC_ProdutosClient/getFilterList',
    }),
    paginatedItems() {
      if (!this.getProdutos || !this.getProdutos.Produtos) return [];

      const items = this.getProdutos.Produtos;
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;
      return items.slice(startIndex, endIndex);
    },
  },
};
</script>
<style scoped lang="scss">

</style>
